var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"f10-profile"},[_c('RkSwitch',{staticClass:"rk-switch",attrs:{"options":_vm.options},model:{value:(_vm.activedTab),callback:function ($$v) {_vm.activedTab=$$v},expression:"activedTab"}}),_c(_vm.isComponent,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }